
class LearnRecipeGrid {
  constructor(container) {
    this.container = container;
    this.limit = parseInt(this.container.dataset.articlesLimit) || 4;
    this.cards = Array.from(this.container.querySelectorAll('.product-card'));
    this.emptyState = this.container.querySelector('.recipes-empty-state');
    
    this.init();
  }

  init() {
    this.boundHandleCutChange = this.handleCutChange.bind(this);
    document.addEventListener('cuts-diagram:cut-change', this.boundHandleCutChange);

    this.syncInitialCut();
  }

  destroy() {
    document.removeEventListener('cuts-diagram:cut-change', this.boundHandleCutChange);
  }


  handleCutChange(event) {
    const { cutName } = event.detail;
    if (cutName) {
      this.filterRecipes(cutName);
    }
  }


  syncInitialCut() {
    const activeHotspot = document.querySelector('.cuts-diagram__hotspot.active');
    if (activeHotspot) {
      const blockId = activeHotspot.dataset.blockId;
      const dataScript = document.querySelector('.cuts-diagram-data');
      if (dataScript) {
        try {
          const cutsData = JSON.parse(dataScript.textContent);
          const cut = cutsData[blockId];
          if (cut && cut.name) {
            this.filterRecipes(cut.name);
            return;
          }
        } catch (e) {
          console.error('Failed to parse cuts data on load', e);
        }
      }
    }

    const detailsTitle = document.querySelector('.cuts-diagram__details-title');
    if (detailsTitle && detailsTitle.textContent && detailsTitle.textContent !== 'Cut Name' && detailsTitle.textContent !== 'No Cut Configured') {
      this.filterRecipes(detailsTitle.textContent);
    }
  }

  /**
   * Filter and show cards matching the active cut name
   * @param {string} cutName - Name of the selected cut
   */
  filterRecipes(cutName) {
    let visibleCount = 0;

    this.cards.forEach(card => {
      const rawTags = card.dataset.articleTags || '';
      const tags = rawTags.split(',').map(tag => tag.trim().toLowerCase()).filter(Boolean);

      const isMatch = this.matchCutWithTags(cutName, tags);

      if (isMatch && visibleCount < this.limit) {
        card.style.display = 'flex';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    if (visibleCount === 0) {
      if (this.emptyState) this.emptyState.style.display = 'block';
    } else {
      if (this.emptyState) this.emptyState.style.display = 'none';
    }
  }


  matchCutWithTags(cutName, articleTags) {
    if (!cutName || !articleTags || articleTags.length === 0) return false;

    const SYNONYMS = {
      'butt': ['shoulder'],
      'ribeye': ['chop', 'chops', 'porkchop', 'porkchops']
    };

    const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
    const normalizedCut = normalize(cutName);
    
    // Split cut name into words (e.g. "Sirloin Steak" -> ["sirloin", "steak"])
    const cutWords = cutName.toLowerCase().split(/\s+/).map(w => w.replace(/[^a-z0-9]/g, '')).filter(Boolean);
    const genericWords = ['steak', 'roast', 'bones', 'chops', 'cut', 'beef', 'pork'];

    // Non-generic words in the cut name
    const specificCutWords = cutWords.filter(w => !genericWords.includes(w));

    return articleTags.some(tag => {
      const normalizedTag = normalize(tag);
      
      // 1. Exact or substring match of full normalized strings
      if (normalizedCut === normalizedTag) return true;
      if (normalizedTag.includes(normalizedCut)) return true;

      // 2. Split tag into words and check for shared specific (non-generic) words
      const tagWords = tag.toLowerCase().split(/\s+/).map(w => w.replace(/[^a-z0-9]/g, '')).filter(Boolean);
      
      // If any specific cut word is present as a word in the tag, it's a match!
      const hasSharedWord = specificCutWords.some(word => tagWords.includes(word));
      if (hasSharedWord) return true;

      const hasSubstringWord = specificCutWords.some(word => {
        return tagWords.some(tagWord => tagWord.includes(word) || word.includes(tagWord));
      });
      if (hasSubstringWord) return true;

      // 4. Synonym match
      const hasSynonymMatch = specificCutWords.some(word => {
        const synonyms = SYNONYMS[word] || [];
        return synonyms.some(syn => tagWords.includes(syn));
      });
      if (hasSynonymMatch) return true;

      return false;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const initLearnRecipes = () => {
    document.querySelectorAll('.learn-recipes-grid-container').forEach(container => {
      if (!container.dataset.recipeGridInitialized) {
        new LearnRecipeGrid(container);
        container.dataset.recipeGridInitialized = 'true';
      }
    });
  };

  initLearnRecipes();

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.learn-recipes-grid-container');
    if (container) {
      new LearnRecipeGrid(container);
      container.dataset.recipeGridInitialized = 'true';
    }
  });
});
